import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IClientNameEditorProps {
    value: string;
    onUpdate: (field: 'name', value: string) => void;
}

export default function ClientNameEditor({ value = '', onUpdate }: IClientNameEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            label={t('common:organization.projects.name')}
            value={value}
            placeholder={'-'}
            onChange={(e) => onUpdate('name', e.target.value)}
        />
    );
}
